import { BodyText, Button, Flex } from '@utilitywarehouse/hearth-react';
import { FormikProps, useFormikContext } from 'formik';

import { BundleQuoteFragment } from '@generated/gql/graphql';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { YourDetailsFormValues } from '@src/types/yourDetails';

import { useSendCbcTerms } from './useSendCbcTerms';
import { useSendEeccContract } from './useSendEeccContract';

interface CustomerDocumentsProps {
  showEeccContract: boolean;
  showCbcTerms: boolean;
  selectedQuotes: BundleQuoteFragment[];
}

const CustomerDocuments = ({
  selectedQuotes,
  showEeccContract,
  showCbcTerms,
}: CustomerDocumentsProps) => {
  const { basketId } = useBasketContext();

  const { values }: FormikProps<YourDetailsFormValues> = useFormikContext();

  const { sendContract: sendEeccContract, loading: sendEeccContractLoading } =
    useSendEeccContract(basketId, values, selectedQuotes);
  const { sendTerms: sendCbcTerms, loading: sendCbcTermsLoading } =
    useSendCbcTerms(basketId, values);

  return (
    <Flex direction="column" spacing="xl">
      {showEeccContract && (
        <Flex direction="column" spacing="md" alignItems="start">
          <BodyText size="md" weight="semibold">
            Broadband and Mobile Contract Summary
          </BodyText>
          <Button
            variant="outline"
            type="button"
            onClick={sendEeccContract}
            loading={sendEeccContractLoading}
          >
            {sendEeccContractLoading
              ? 'Sending...'
              : 'Email summary to customer'}
          </Button>
        </Flex>
      )}
      {showCbcTerms && (
        <Flex direction="column" spacing="md" alignItems="start">
          <BodyText size="md" weight="semibold">
            Cashback Card Terms & Conditions
          </BodyText>
          <Button
            variant="outline"
            type="button"
            onClick={sendCbcTerms}
            loading={sendCbcTermsLoading}
          >
            {sendCbcTermsLoading ? 'Sending...' : 'Email terms to customer'}
          </Button>
        </Flex>
      )}
      <BodyText>
        The customer will agree that they have received and read
        {showEeccContract && showCbcTerms
          ? ' these documents '
          : ' this document '}
        in the Terms and Conditions at the end of this form.
      </BodyText>
    </Flex>
  );
};

export { CustomerDocuments };
